// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"99cf0937","582":"72f00f9a"}[chunkId] + ".chunk.js";
};